import {
  Route,
  RouterProvider,
  createBrowserRouter,
  createRoutesFromElements,
  Navigate,
} from "react-router-dom";

import { Layout } from "../components/Layout";
import { ContactPage } from "./ContactPage";
import { LoginPage } from "./LoginPage";
import { LoginCompletePage } from "./LoginCompletePage";
import { StatusPage } from "./StatusPage";
import { ProtectedRoute } from "../components/ProtectedRoute";
import { ProductsPage } from "./ProductsPage";
import { InstallInfoPage } from "./InstallInfoPage";
import { TermsPage } from "./TermsPage";
import { PrivacyPolicyPage } from "./PrivacyPolicyPage";
import { BuyLicensePage } from "./BuyLicensePage";
import { MachinesPage } from "./MachinesPage";

const baseUrl: string | undefined = document.querySelector('base')?.getAttribute('href') ?? undefined;

export const routes = createRoutesFromElements(
  <Route>
    <Route element={<Layout />}>
      <Route path="/" element={<LoginPage />} />
    </Route>
    <Route element={<Layout />}>
      <Route path="/early-access" element={<ContactPage />} />
    </Route>
    <Route element={<Layout />}>
      <Route index path="/login" element={<LoginPage />} />
      <Route index path="/login/complete" element={<LoginCompletePage />} />
    </Route>
    <Route element={<Layout />}>
      <Route path="/try" element={<BuyLicensePage />} />
    </Route>
    <Route element={<Layout />}>
      <Route index path="/install-info" element={<InstallInfoPage />} />
    </Route>
    <Route element={<Layout />}>
      <Route index path="/terms" element={<TermsPage />} />
    </Route>
    <Route element={<Layout />}>
      <Route index path="/privacy-policy" element={<PrivacyPolicyPage />} />
    </Route>
    <Route element={<ProtectedRoute />}>
      <Route index path="/products" element={<ProductsPage />} />
      <Route index path="/machines" element={<MachinesPage />} />
      <Route index path="/test" element={<StatusPage />} />
    </Route>
    {/* fallback route */}
    <Route element={<Layout />}>
      <Route index path="*" element={<Navigate to="/" replace />} />
    </Route>
  </Route>
);

const router = createBrowserRouter(routes, { basename: baseUrl });

export const AppRouterProvider = () => {
  return (
    <RouterProvider router={router} />
  )
}
